import { CustomField } from "@/backend/models/customFields/customField";
import { ObjectCustomField } from "@/backend/models/customFields/objectCustomField";
import { Parameter } from "@/backend/models/parameter";
import { HelpIcon } from "@/frontend/SVGs/HelpIcon";
import { I18n } from "@/i18n/I18n";
import { ParameterType, ParameterInputType } from "@/types/parameterTypes";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { CustomFieldInput } from "../customFIelds/CustomFieldInput";
import { NonPrimitiveParameter } from "./NonPrimitiveParameter";
import { ParameterTitle } from "./ParameterTypeLabel";
import { ReferenceLabel } from "./ReferenceLabel";
import { useParameterIsDisabled } from "@/frontend/hooks/useParameterIsDisabled";
import { useParameterIsOperationInput } from "@/frontend/hooks/useParameterIsOperationInput";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import { ObjectProperty } from "@/backend/models/objectInstance";

export function ParameterItemRun(props: { parameter: Parameter, alwaysEnabled?: boolean }) {
  const { parameter, alwaysEnabled } = props;

  return (
    <div id={parameter.id}>
      <ReferenceLabel consumerId={parameter.id} />
      <ParameterTitle parameter={parameter} />
      {parameter.description && <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={<Popover>
          <Popover.Header as="h3">{I18n.get('description')}</Popover.Header>
          <Popover.Body>
            {parameter.description}
          </Popover.Body>
        </Popover>}
      >
        <button type='button' className='btn btn-sm mb-1' aria-label={I18n.get('description')}><HelpIcon /></button>
      </OverlayTrigger>}
      <ParameterItemRunValue parameter={parameter} alwaysEnabled={alwaysEnabled} />
    </div>
  );
}

export function ParameterItemRunValue(props: { parameter: Parameter, alwaysEnabled?: boolean }) {
  const { parameter, alwaysEnabled } = props;
  const isDisabled = useParameterIsDisabled(parameter) && !alwaysEnabled;
  const isInput = useParameterIsOperationInput(parameter);

  if (parameter.inputType === ParameterInputType.TABLE) {
    return <TableParameter fields={parameter.fields} />;
  }

  if (!parameter.isPrimitive()) {
    return <NonPrimitiveParameter parameter={parameter} disabled={isDisabled} runView/>;
  }


  return (
    <div className='d-flex gap-3 align-items-start'>
      <div className='flex-fill'>
        <CustomFieldInput
          customField={parameter.fields[0]}
          readOnly={isDisabled}
          hideFilePreview={parameter.type !== ParameterType.FIELD}
          isInput={isInput}
        />
      </div>
    </div>
  );
}


function getTableCellDisplayValue(property: ObjectProperty): string {
  if (property.type === CUSTOM_FIELD_TYPES.File && property.file) {
    return property.file.fileName || property.value;
  }
  return property.value || '';
}

export function TableParameter(props: { fields: CustomField[] }) {
  const { fields } = props;

  return (
    <table className='table table-sm table-bordered table-striped'>
      <thead className='table-secondary'>
      <tr>
        {Parameter.propertyKeys(fields).map(property => <th key={property.keyId}>{property.title || property.key}</th>)}
        </tr>
      </thead>
      <tbody>
        {fields.map((field) => (
          <tr key={field.id}>
            {field instanceof ObjectCustomField && field.objectInstance.properties.map(property => (
          <td key={property.valueId}>{getTableCellDisplayValue(property)}</td>
        ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
